import { render, staticRenderFns } from "./workshops.vue?vue&type=template&id=2fcee972&scoped=true&"
import script from "./workshops.vue?vue&type=script&lang=js&"
export * from "./workshops.vue?vue&type=script&lang=js&"
import style0 from "./workshops.vue?vue&type=style&index=0&id=2fcee972&scoped=true&lang=css&"
import style1 from "./workshops.vue?vue&type=style&index=1&id=2fcee972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcee972",
  null
  
)

export default component.exports